import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import LineFestivalsIcon from 'LuxKit/Icons/line/LineFestivalsIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(12)};
  padding: ${rem(12)};
  background: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${rem(8)};
  box-shadow:
    0 ${rem(1)} ${rem(1.5)} rgba(0, 0, 0, 0.07),
    0 ${rem(1.5)} ${rem(5)} rgba(0, 0, 0, 0.05);
`

const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface Props {
  /**
   * The tier that was retained
   */
  tier: App.LoyaltyTier
  /**
   * The date until which the benefits are valid
   */
  reviewDate?: string
}

function LoyaltyDrawerCongratulationsBanner({
  tier,
  reviewDate,
}: Props) {
  const intl = useIntl()
  const tierName = getLoyaltyTierDisplayName(tier)

  return (
    <BannerContainer>
      <IconWrapper>
        <LineFestivalsIcon size={32} colour="neutral-two" />
      </IconWrapper>
      <Group direction="vertical" gap={2}>
        <BodyText variant="small" weight="bold" colour="neutral-one">
          {intl.formatMessage(
            {
              id: 'r21ABumNzE7qAfsct5WR',
              defaultMessage: 'Congratulations you have retained {tierName} for another year.',
              description: 'Banner congratulating user on retaining their loyalty tier for another year',
            },
            { tierName },
          )}
        </BodyText>
        {reviewDate && (
          <BodyText variant="small" colour="neutral-one">
            <FormattedMessage
              id="tVYmPHkbjS-OE7jNuhpK"
              defaultMessage="Review date {date}"
              description="Loyalty tier review date display in drawer congratulations banner"
              values={{ date: <FormatDateTime value={reviewDate} format="dmy-casual-short" /> }}
            />
          </BodyText>
        )}
      </Group>
    </BannerContainer>
  )
}

export default LoyaltyDrawerCongratulationsBanner
